module.exports = __webpack_public_path__ + "img/move-icon-default.30ce5b6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/move-icon-default.png
// module id = EVt1
// module chunks = 2 3 33 35 36 44 45 46 146 163